<template>
  <div class="mt-5">
    <base-section-title>#Formation'</base-section-title>
    <div class="mt-5">
      <formation-item v-for="(formation, index) in $t('homepage.formation')" :key="`formation_${index}`" class="formation-item"
        :date="formation.date"
        :type="formation.type"
        :institute="formation.institute">{{ formation.name }}</formation-item>
    </div>
  </div>
</template>

<script>
import BaseSectionTitle from '../../base/BaseSectionTitle'
import FormationItem from '../../base/formation/FormationItem'
export default {
  name: 'FormationSection',
  components: { FormationItem, BaseSectionTitle }
}
</script>

<style scoped>
.formation-item:nth-child(n) {
  @apply mb-3
}
.formation-item:last-child {
  @apply mb-0
}
</style>
